<template>
	<section>
		<div class="title-box" v-for="(item, idx) in Titles" :key="idx">
			<h3 class="title one-line">{{item.Content}}</h3>
		</div>
	</section>
</template>

<script>
export default {
	name: 'SingleRow',
	props: ['Titles']
}
</script>

<style lang="scss" scoped>
.title-box {
	display: -webkit-box;
	-webkit-box-align: center;
	-webkit-box-pack: justify;
	height: 45px;
	margin-right: 8px;
	.title {
		display: block;
		font-size: 16px;
		color: #333;
		font-weight: bold;
		-webkit-box-flex: 1;
	}
}
</style>



// WEBPACK FOOTER //
// src/template/title/SingleRow.vue